export class SUBS_ROUTES {
	static ROOT: string = '/subcontractors';
	static ROOT_1: string = 'subcontractors';
	static DOCUMENTS: string = 'documents';
	static CASH_OUT: string = 'cash_out';
	static REJECTED_DOCUMENTS: string = 'rejected';
}